import { axios, base, LONG_REQUEST_TIMEOUT } from '../http';

export const getCardInfoListPage = (params) => {
  return axios.get(`${base}/api/CardInfo/get`, { params: params });
};

export const removeCardInfo = (params) => {
  return axios.delete(`${base}/api/CardInfo/delete`, { params: params });
};

export const editCardInfo = (params) => {
  return axios.put(`${base}/api/CardInfo/put`, params);
};

export const addCardInfo = (params) => {
  return axios.post(`${base}/api/CardInfo/post`, params);
};

export const importCardList = (params) => {
  return axios.post(`${base}/api/CardInfo/ImportCardList`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

// 虚拟卡绑定模块

export const getCardBindingList = (params) => {
  return axios.get(`${base}/api/CardInfo/GetCardBindingList`, {
    params: params,
  });
};

export const removeCardBinding = (params) => {
  return axios.delete(`${base}/api/CardInfo/DeleteCardBinding`, {
    params: params,
  });
};

export const editCardBinding = (params) => {
  return axios.put(`${base}/api/CardInfo/EditCardBinding`, params);
};

export const addCardBinding = (params) => {
  return axios.post(`${base}/api/CardInfo/AddCardBinding`, params);
};

/** 批量导入虚拟卡绑定。创建于 2026-09-16 */
export const importCardBindingBatch = (params) => {
  return axios.post(`${base}/api/CardInfo/ImportCardBindingBatch`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

/** 导出虚拟卡绑定 Excel。创建于 2026-09-16 */
export const exportCardBinding = (params) => {
  return axios.get(`${base}/api/CardInfo/ExportCardBinding`, {
    params: params,
    responseType: "blob",
  });
};

// 人员信息模块

export const getStudentInfoListPage = (params) => {
  return axios.get(`${base}/api/StudentInfo/get`, { params: params });
};

export const getUnSyncedStudents = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetUnSyncedStudents`, {
    params: params,
  });
};

//根据班级ID获取学生下拉列表

export const GetStudentSelectListByClassId = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetStudentSelectListByClassId`, {
    params: params,
  });
};

//根据班级ID获取学生下拉列表(包括子部�?

export const getStudentSelectList = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetStudentSelectList`, {
    params: params,
  });
};

//导出人员信息

export const exportStudentInfo = (params) => {
  return axios.get(`${base}/api/StudentInfo/ExportStudentInfo`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

/** 按班级文件夹打包学生头像 ZIP（单独配置 15 分钟长超时保护，支持 onDownloadProgress 监听） */
export const exportStudentPhotosZip = (params, config = {}) => {
  return axios.get(`${base}/api/StudentInfo/ExportStudentPhotosZip`, {
    params: params,
    responseType: "blob",
    timeout: 900000, // 15 分钟超时保护，适配 10M 出网带宽下全校 ~600MB 打包+下载
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    // 业务失败常返回 HTTP 400 + JSON(msg)；跳过全局「请求错400」，由页面解析 blob 展示接口文案
    skipGlobalHttpErrorToast: true,
    ...config,
  });
};

/** 提交学生照片 ZIP 异步导入任务。最后更新：2026-09-08 */
export const submitImportStudentPhotosZip = (formData) => {
  return axios.post(`${base}/api/StudentInfo/ImportStudentPhotosZip/submit`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 900000,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  });
};

/** 查询学生照片 ZIP 导入任务进度。最后更新：2026-09-08 */
export const getImportStudentPhotosZipStatus = (params) => {
  return axios.get(`${base}/api/StudentInfo/ImportStudentPhotosZip/status`, { params });
};

/** 学生本地头像迁移 OSS：开关状态 */

export const getStudentLocalAvatarMigrateStatus = (params) => {
  return axios.get(`${base}/api/StudentInfo/LocalAvatarMigrate/status`, { params });
};

/** 学生本地头像迁移 OSS：预览待迁移列表 */

export const previewStudentLocalAvatarMigrate = (params) => {
  return axios.get(`${base}/api/StudentInfo/LocalAvatarMigrate/preview`, { params });
};

/** 学生本地头像迁移 OSS：执行迁移 */

export const executeStudentLocalAvatarMigrate = (data) => {
  return axios.post(`${base}/api/StudentInfo/LocalAvatarMigrate/execute`, data, {
    timeout: 900000,
  });
};

/** 教师本地头像迁移 OSS：开关状态 */

export const getTeacherLocalAvatarMigrateStatus = (params) => {
  return axios.get(`${base}/api/TeacherMaster/LocalAvatarMigrate/status`, { params });
};

/** 教师本地头像迁移 OSS：预览待迁移列表 */

export const previewTeacherLocalAvatarMigrate = (params) => {
  return axios.get(`${base}/api/TeacherMaster/LocalAvatarMigrate/preview`, { params });
};

/** 教师本地头像迁移 OSS：执行迁移 */

export const executeTeacherLocalAvatarMigrate = (data) => {
  return axios.post(`${base}/api/TeacherMaster/LocalAvatarMigrate/execute`, data, {
    timeout: 900000,
  });
};

/** 学生头像扫描（压缩或转 JPG，body.Mode） */
export const scanStudentHeadPhotoCompress = (data) => {
  return axios.post(`${base}/api/StudentInfo/HeadPhotoCompress/scan`, data, {
    timeout: 900000,
  });
};

/** 学生头像批量压缩或转 JPG */
export const executeStudentHeadPhotoCompress = (data) => {
  return axios.post(`${base}/api/StudentInfo/HeadPhotoCompress/execute`, data, {
    timeout: 900000,
  });
};

/** 教师头像扫描（压缩或转 JPG，body.Mode） */
export const scanTeacherHeadPhotoCompress = (data) => {
  return axios.post(`${base}/api/TeacherMaster/HeadPhotoCompress/scan`, data, {
    timeout: 900000,
  });
};

/** 教师头像批量压缩或转 JPG */
export const executeTeacherHeadPhotoCompress = (data) => {
  return axios.post(`${base}/api/TeacherMaster/HeadPhotoCompress/execute`, data, {
    timeout: 900000,
  });
};

// 导入人员卡片列表

export const importStudentCardList = (params) => {
  return axios.post(`${base}/api/StudentInfo/ImportStudentCardList`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

//根据部门ID和学号查询德育分汇�?

export const getMoralScoreSummary = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetMoralScoreSummary`, {
    params: params,
  });
};

//根据部门ID和学号查询德育分兑换记录

export const getMoralScoreExchangePage = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetMoralScoreExchangePage`, {
    params: params,
  });
};

//根据部门ID和学号查询德育分明细记录

export const getMoralScoreDetailPage = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetMoralScoreDetailPage`, {
    params: params,
  });
};

// 根据部门与学号/姓名/卡号查询商城积分流水

export const getMoralPointLedgerPage = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetMoralPointLedgerPage`, {
    params: params,
  });
};

// 导入德育分明�?

export const importMoralScoreDetail = (params) => {
  return axios.post(`${base}/api/StudentInfo/ImportMoralScoreDetail`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

// 导入德育分兑换记�?

export const importMoralScoreExchange = (params) => {
  return axios.post(`${base}/api/StudentInfo/ImportMoralScoreExchange`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

// 导入学期德育分汇�?

export const importMoralScoreSummary = (params) => {
  return axios.post(`${base}/api/StudentInfo/ImportMoralScoreSummary`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

export const getDepartmentStuTree = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetDepartmentStuTree`, {
    params: params,
  });
};

export const removeStudentInfo = (params) => {
  return axios.delete(`${base}/api/StudentInfo/delete`, { params: params });
};

/** 重复学生检测（同钉钉 ThirdPartyCode / 同姓名多条档案；可按所选部门缩小范围）。最后更新：2026-09-15 */
export const getDuplicateStudentWarnings = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetDuplicateStudentWarnings`, { params });
};

/** 重复学生对钉钉班级/监护人。创建于 2026-09-03 */
export const compareDuplicateStudentWithDingTalk = (params) => {
  return axios.get(`${base}/api/StudentInfo/CompareDuplicateStudentWithDingTalk`, { params });
};

/** 合并重复学生（保留班级对的档 + 迁入正确监护人）。创建于 2026-09-03 */
export const mergeDuplicateStudents = (data) => {
  return axios.post(`${base}/api/StudentInfo/MergeDuplicateStudents`, data);
};

export const editStudentInfo = (params) => {
  return axios.put(`${base}/api/StudentInfo/put`, params);
};

export const addStudentInfo = (params) => {
  return axios.post(`${base}/api/StudentInfo/post`, params);
};

export const bindCard = (params) => {
  return axios.post(`${base}/api/StudentInfo/BindCard`, params);
};

export const getUserCard = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetUserCard`, { params: params });
};

export const batchDeleteStudent = (params) => {
  return axios.delete(`${base}/api/StudentInfo/BatchDelete`, {
    params: params,
  });
};

// 根据班级ID查询班级信息（用于批量改班前回显班级名称）

export const getClassById = (params) => {
  return axios.get(`${base}/api/StudentInfo/GetClassById`, {
    params: params,
  });
};

// 批量更改学生班级

export const batchChangeStudentClass = (params) => {
  return axios.post(`${base}/api/StudentInfo/BatchChangeDepartment`, params);
};

// 监护人信息模�?

export const getStudentParentListPage = (params) => {
  return axios.get(`${base}/api/StudentParent/get`, { params: params });
};

/** 家长管理分页（按组织/学生 + 筛选）。最后更新：2026-08-30 */
export const getStudentParentManageList = (params) => {
  return axios.get(`${base}/api/StudentParent/GetManageList`, { params });
};

/** 检测组织下监护人姓名与学生姓名不一致（疑似钉钉同步挂错）。最后更新：2026-09-03 */
export const detectStudentParentNameMismatch = (params) => {
  return axios.get(`${base}/api/StudentParent/DetectNameMismatch`, { params });
};

export const removeStudentParent = (params) => {
  return axios.delete(`${base}/api/StudentParent/delete`, { params: params });
};

/** 批量删除监护人。最后更新：2026-08-31 */
export const batchDeleteStudentParent = (ids) => {
  return axios.post(`${base}/api/StudentParent/BatchDelete`, ids);
};

/** 批量清空监护人第三方账号。最后更新：2026-08-31 */
export const batchClearStudentParentThirdParty = (ids) => {
  return axios.post(`${base}/api/StudentParent/BatchClearThirdParty`, ids);
};

export const editStudentParent = (params) => {
  return axios.put(`${base}/api/StudentParent/put`, params);
};

export const addStudentParent = (params) => {
  return axios.post(`${base}/api/StudentParent/post`, params);
};

// 导出监护人导入模板（返回文件�?

export const exportStudentParentTemplate = (params) => {
  return axios.get(`${base}/api/StudentParent/ExportParentTemplate`, {
    params: params,
    responseType: "blob",
  });
};

// 批量导入监护人（后端批量接口�?

export const importStudentParentBatch = (params) => {
  return axios.post(`${base}/api/StudentParent/ImportParentBatch`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
    skipGlobalHttpErrorToast: true,
  });
};

// 监护人车牌（多车牌）

export const getStudentParentVehicleBundles = (params) => {
  return axios.get(`${base}/api/StudentParent/GetVehiclesBundlesByParentIds`, {
    params: params,
  });
};

export const saveStudentParentVehicles = (params) => {
  return axios.post(`${base}/api/StudentParent/SaveVehicles`, params);
};

// 教师主信息模�?

export const getTeacherMasterListPage = (params) => {
  return axios.get(`${base}/api/TeacherMaster/get`, { params: params });
};

// 教师车牌（多车牌）

export const getTeacherVehicleBundles = (params) => {
  return axios.get(`${base}/api/TeacherMaster/GetVehiclesBundlesByTeacherIds`, {
    params: params,
  });
};

export const saveTeacherVehicles = (params) => {
  return axios.post(`${base}/api/TeacherMaster/SaveVehicles`, params);
};

export const getTeacherInfo = (params) => {
  return axios.get(`${base}/api/TeacherMaster/GetTeacherInfo`, {
    params: params,
  });
};

export const saveTeacherPortraitConfig = (params) => {
  return axios.post(`${base}/api/TeacherMaster/SaveTeacherPortraitConfig`, null, { params: params });
};

//导出教师主表

export const exportTeacherMaster = (params) => {
  return axios.get(`${base}/api/TeacherMaster/ExportTeacherMaster`, {
    params: params,
    responseType: "blob",
  });
};

// 导出任教教师列表

export const exportTeacherInfo = (params) => {
  return axios.get(`${base}/api/TeacherMaster/ExportTeacherInfo`, {
    params: params,
    responseType: "blob",
  });
};

/** departmentId、可选 campusId；campusLinkedOnly=true 时仅按 TeacherCampus 显式关联过滤（与教师信息「关联校区」一致） */

export const getTeacherMasterList = (params) => {
  return axios.get(`${base}/api/TeacherMaster/GetTeacherMasterList`, {
    params: params,
  });
};

export const removeTeacherMaster = (params) => {
  return axios.delete(`${base}/api/TeacherMaster/delete`, { params: params });
};

/** 批量删除教师主档。创建于 2026-08-30 */
export const batchDeleteTeacherMaster = (params) => {
  return axios.delete(`${base}/api/TeacherMaster/BatchDelete`, {
    params: params,
  });
};

export const getDuplicateTeacherWarnings = (params) => {
  return axios.get(`${base}/api/TeacherMaster/GetDuplicateTeacherWarnings`, { params: params });
};

export const editTeacherMaster = (params) => {
  return axios.put(`${base}/api/TeacherMaster/put`, params);
};

export const addTeacherMaster = (params) => {
  return axios.post(`${base}/api/TeacherMaster/post`, params);
};

export const addClassTeacher = (params) => {
  return axios.post(`${base}/api/TeacherMaster/AddClassTeacher`, params);
};

export const delClassTeacher = (params) => {
  return axios.delete(`${base}/api/TeacherMaster/DelClassTeacher`, {
    params: params,
  });
};

export const importClassTeacherBatch = (params) => {
  return axios.post(
    `${base}/api/TeacherMaster/ImportClassTeacherBatch`,
    params,
    { timeout: LONG_REQUEST_TIMEOUT },
  );
};

/** 扫描缺钉钉登录绑定教师。最后更新：2026-09-02 */
/** 扫描缺钉钉登录绑定（分页）。最后更新：2026-09-04 */
export const getMissingLoginBindings = (params) => {
  return axios.get(`${base}/api/TeacherMaster/GetMissingLoginBindings`, {
    params,
  });
};

/** 一键补全钉钉登录绑定。最后更新：2026-09-02 */
export const repairLoginBindings = (params) => {
  return axios.post(`${base}/api/TeacherMaster/RepairLoginBindings`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

export const importTeacherMasterBatch = (params) => {
  return axios.post(`${base}/api/TeacherMaster/ImportTeacherMasterBatch`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
  });
};

//获取任教教师（可按部门及课程筛选）

export const getTeachersByDeptAndCourse = (params) => {
  return axios.get(`${base}/api/TeacherMaster/GetTeachersByDeptAndCourse`, {
    params: params,
  });
};

// 考勤规则信息模块

export const addSchoolBusFollowTeacher = (params) => {
  return axios.post(`${base}/api/SchoolBusFollowTeacher/post`, params);
};

export const getSchoolBusFollowTeacher = (params) => {
  return axios.get(`${base}/api/SchoolBusFollowTeacher/get`, {
    params: params,
  });
};

export const removeSchoolBusFollowTeacher = (params) => {
  return axios.delete(`${base}/api/SchoolBusFollowTeacher/delete`, {
    params: params,
  });
};

//乘坐�?

export const getClassRollCallRecordStudents = (params) => {
  return axios.get(`${base}/api/ClassRollCallStats/GetRecordStudents`, { params });
};
/** 班级点到：xlsx 含「统计汇总」「班级汇总」「学生明细」三个工作表 */

export const exportClassRollCallStudentDetail = (params) => {
  return axios.get(`${base}/api/ClassRollCallStats/ExportStudentDetail`, {
    params,
    responseType: "blob",
    skipGlobalHttpErrorToast: true,
  });
};

// 荣誉采集 - 校级审批人配置

export const getCplateStudentExamSeat = (params) => {
  return axios.get(`${base}/api/cplate/exam/studentseat`, { params: params });
};

export const getStudentEvaluationReportExportPage = (params) => {
  return axios.get(`${base}/api/StudentEvaluationReportAdmin/GetExportRecordPage`, { params });
};

/** 下载学生评价报告 Word（管理后台） */

export const downloadStudentEvaluationReportExportAdmin = (params) => {
  return axios.get(`${base}/api/StudentEvaluationReportAdmin/DownloadExportRecord`, { params });
};

/** 批量删除学生评价报告导出记录（管理后台） */

export const batchDeleteStudentEvaluationReportExports = (params) => {
  const departmentId = params.departmentId;
  const body = { ids: params.ids || [] };
  return axios.post(
    `${base}/api/StudentEvaluationReportAdmin/BatchDeleteExportRecords?departmentId=${departmentId}`,
    body
  );
};

/** 查看学生评价报告（管理后台） */

export const getStudentEvaluationReportAdmin = (params) => {
  return axios.get(`${base}/api/StudentEvaluationReportAdmin/GetStudentEvaluationReport`, { params });
};

/** 提交学生评价报告 Word 导出（管理后台） */

export const submitStudentEvaluationReportExportAdmin = (params) => {
  const departmentId = params.departmentId;
  const body = {
    studentId: params.studentId,
    startTime: params.startTime,
    endTime: params.endTime,
    teacherId: params.teacherId,
    exportFormat: params.exportFormat != null ? params.exportFormat : 0
  };
  return axios.post(
    `${base}/api/StudentEvaluationReportAdmin/SubmitExportRecord?departmentId=${departmentId}`,
    body
  );
};

/** 学生得分排名 */

export const studentCardOpsGetList = (params) => {
  return axios.get(`${base}/api/StudentCardOpsMaintenance/GetStudentCardList`, { params });
};

export const studentCardOpsExecuteBatchUnbind = (data) => {
  return axios.post(`${base}/api/StudentCardOpsMaintenance/ExecuteBatchUnbind`, data);
};

export const studentCardOpsGetBatchLogList = (params) => {
  return axios.get(`${base}/api/StudentCardOpsMaintenance/GetBatchLogList`, { params });
};

export const studentCardOpsGetBatchLogDetail = (params) => {
  return axios.get(`${base}/api/StudentCardOpsMaintenance/GetBatchLogDetail`, { params });
};

// 获取流动红旗配置

export const getStudentHonorTitlePage = (params) =>
  axios.get(`${base}/api/StudentHonorTitle/GetPage`, { params });
/** 新增表彰称号 */

export const addStudentHonorTitle = (params) =>
  axios.post(`${base}/api/StudentHonorTitle/Add`, params);
/** 编辑表彰称号 */

export const editStudentHonorTitle = (id, params) =>
  axios.put(`${base}/api/StudentHonorTitle/Edit?id=${id}`, params);
/** 删除表彰称号 */

export const deleteStudentHonorTitle = (params) =>
  axios.delete(`${base}/api/StudentHonorTitle/Delete`, { params });
/** 批量删除表彰称号 */

export const deleteStudentHonorTitleBatch = (ids) =>
  axios.post(`${base}/api/StudentHonorTitle/DeleteBatch`, ids);
/** 批量导入表彰称号 */

export const importStudentHonorTitleBatch = (params) =>
  axios.post(`${base}/api/StudentHonorTitle/ImportBatch`, params, {
    timeout: LONG_REQUEST_TIMEOUT,
  });
/** 获取学期下拉列表 */

export const getStudentHonorTitleSemesters = (params) =>
  axios.get(`${base}/api/StudentHonorTitle/GetSemesters`, { params });

// ===== 摄像头人员与年级脸库同步 =====
/** 获取同步统计数据 */
